module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8019.b0c2165b.png";